import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
/* eslint-disable-next-line import/no-cycle */
import { labelSelector, styleSelector } from './selectors';
import widthSelector from './selectors/widthSelector';

// column wraps one child
const Column = _ref => {
  let _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? null : _ref$style,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? {
      size: 12
    } : _ref$width,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  const classes = "align-self-end ".concat(className, " Column");
  return /*#__PURE__*/React.createElement(Col, {
    className: classes,
    md: width,
    style: style
  }, children);
};
Column.propTypes = {
  children: PropTypes.node,
  content: PropTypes.shape({}),
  // eslint-disable-next-line react/no-unused-prop-types
  minControlWidth: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  width: PropTypes.shape({})
};
export { Column as TestGridCol, widthSelector as testWidthSelector };
export default entityComposition(Column, [], {
  label: labelSelector,
  width: widthSelector,
  style: styleSelector
});